/** First character uppercase; rest unchanged (e.g. test-user → Test-user). */
export function formatDisplayUsername(username: string): string {
    if (!username) {
        return '';
    }
    return username.charAt(0).toUpperCase() + username.slice(1);
}
